export const locale = {
    lang: 'pl',
    data: {
        'DELETE': 'Usuń',
        'EDIT': 'Edycja',
        'SAVE': 'Zapisz',
        'Cancel': 'Anuluj',
        'CANCEL': 'Anuluj',
        'Confirm': 'Potwierdź',
        'Are you sure you want to left current window?': 'Czy na pewno chcesz opuścić bieżące okno?',
        'Confirm deletion': 'Potwierdź usunięcie',
        'Are you sure you want to delete selected Menu?': 'Czy na pewno chcesz usunąć wybrane menu?',
        'Resource': 'Zasób',
        'Save': 'Zapisz',
        'Cash report item': 'Nowa pozycja do raportu',
        "Create cash report item": "Nowy pozycja do raportu kasowego",
        "Proof is required!": "Dowód jest wymagany!",
        "Outcome is required!": "Kwota rozchodu jest wymagana!",
        "Income is required!": "Kwota przychodu jest wymagana!",
        "Close cash report": "Zamknij raport kasowy",
        "Close": "Zamknij",
        "Comments": "Uwagi",
        "Comments are required when provided cash is different than calculated.": "Komentarz jest wymagany jeśli podana kwota jest inna niż obliczona",
        "Provided cash value is different than calculated. Add comments!": "Podana kwota jest inna niż wyliczona. Dodaj kkomentarz!",
        "Open": "Otwórz"
    }
};
